import { withInstall } from '../../../utils/with-install'
import ToolBar from './ToolBar.vue'

export const ElAmapControlToolBar = withInstall(ToolBar)
export default ElAmapControlToolBar
